import { render, staticRenderFns } from "./distributori.vue?vue&type=template&id=00f1a113&"
import script from "./distributori.vue.ts?vue&type=script&lang=ts&"
export * from "./distributori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports